export default {
  app: () => import("/home/josed/Documents/CODE/relowcode/app/layouts/app.vue").then(m => m.default || m),
  app2: () => import("/home/josed/Documents/CODE/relowcode/app/layouts/app2.vue").then(m => m.default || m)
}